// extracted by mini-css-extract-plugin
module.exports = {"select":"select_select__x7tPT","selectWidthAuto":"select_selectWidthAuto__x5j3y","select--title":"select_select--title__2bMQ_","select__control":"select_select__control__1j1oG"};